import AddContactModal from "./AddContactDrawer";
import EditContactModal from "./EditContactDrawer";

export { AddContactModal, EditContactModal };

export const MODALS = {
  addContact: AddContactModal,
  editContact: EditContactModal,
};
